import { Button, Modal } from '@distribusion/owl-frontend-ui'
import React, { ReactElement } from 'react'

import { useTranslation } from '@lib/i18n'
import textUtils from '@lib/text'

import '@components/TermsAndPrivacy/TermsModal/index.scss'

interface TermsModalProps {
  opened: boolean
  onClose: () => void
  text: string
}

const TermsModal = ({ onClose, text, opened }: TermsModalProps): ReactElement => {
  const { t } = useTranslation()

  const termsFooter = (
    <div className="row p-3 end">
      <Button onClick={onClose} color="secondary">
        {t('privacyPolicy.close')}
      </Button>
    </div>
  )

  return (
    <Modal opened={opened} onClose={onClose} title={t('checkout.bookingDetails.terms.title')} footer={termsFooter}>
      <div className="p-6">
        <pre className="terms-content">{textUtils.format(text)}</pre>
      </div>
    </Modal>
  )
}

export default TermsModal
